import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

export interface EmptyStateProps {
	icon?: LucideIcon;
	title: ReactNode;
	description?: ReactNode;
	action?: ReactNode;
	className?: string;
}

/**
 * Унифицированное «пусто» для таблиц и списков.
 * Стиль: dashed border, центровка, подсказка + опциональный CTA.
 */
export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
	return (
		<div
			className={cn(
				"flex flex-col items-center justify-center rounded-lg border border-dashed border-slate-300 bg-white p-8 text-center",
				className,
			)}
		>
			{Icon ? <Icon className="mb-3 h-8 w-8 text-slate-400" aria-hidden /> : null}
			<p className="text-sm font-medium text-slate-700">{title}</p>
			{description ? <p className="mt-1 max-w-md text-sm text-slate-500">{description}</p> : null}
			{action ? <div className="mt-4">{action}</div> : null}
		</div>
	);
}
